import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

export const FormWrapper = styled.div`
  ${media.xs`
    min-width: 100%;
  `}
  ${media.sm`
    min-width: 100%;
  `}
  ${media.md`
    min-width: 500px;
  `}
`
export const FormContainer = styled.div`
  background: #fff;
  padding: 40px 40px 20px 40px;
  margin-bottom: 1.25rem;

  ${media.xs`
      padding: 20px;
  `}
`
export const FormFooter = styled.div`
padding: 1.875rem 2.5rem;
display: flex;
justify-content: flex-end;
border-top: 0.0625rem solid #eee;
`
export const FormContent = styled.div``

